import { endLoading, endProcessing, startLoading } from '../actions/loadingAction';
import * as logAction from '../actions/logAction';
import * as actionsPhysicalConfirmation from '../actions/physicalConfirmationAction';
import { ENUMS } from '../utils/constants';
import { getUrlPhysicalConfirmationApi, language, parseParams, showMessageToastCustom, translate } from '../utils/util';
import HttpService from './HttpService';
import * as auth from './auth';

const httpService = new HttpService(getUrlPhysicalConfirmationApi(window));

export default class PhysicalConfirmationService {

    static search(filter, callback) {
        if (navigator.onLine) {
            let msg = '';
            return (dispatch) => {
                httpService.instance.get(`/api/receipt`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        var data = response.data?.data;
                        dispatch(actionsPhysicalConfirmation.update(data));
                        dispatch(actionsPhysicalConfirmation.resetReceipsGroup());
                        dispatch(actionsPhysicalConfirmation.resetReceipsCimPallet());
                        dispatch(this.getTransmissions({ mvm: data.mvmNumber, journey: data.journey, dock: filter.dock, shed: filter.shed, print: false }));
                        dispatch(this.getReceiptStorage({ mvm: data.mvmNumber, journey: data.journey, dock: filter.dock, shed: filter.shed, print: true, truckKanban: filter.truckKanban }));
                    } else {
                        dispatch(this.resetPhisicalConfirmation());
                    }
                    msg = response.data;
                    if (callback) {
                        callback(response.data);
                    }

                }).catch((error) => {
                    if (msg !== '') {
                        showMessageToastCustom(translate('warning', 'general'), msg, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    else {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    dispatch(this.resetPhisicalConfirmation());
                }).finally(() => {
                    dispatch(endLoading());
                    dispatch(endProcessing());
                });
            };
        }
        if (callback) {
            callback();
        }
    }

    static searchList(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/receipt/list`, filter).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        var data = response.data?.data;
                        let receiptList = [];

                        data.forEach(pc => {
                            pc.receipts.forEach(receipt => {
                                receiptList.push(receipt);
                            });
                        });

                        var receiptIds = receiptList.map((obj) => obj.id);

                        dispatch(actionsPhysicalConfirmation.updatePhysicalConfirmationList({
                            physicalConfirmationList: response.data?.data,
                            receipts: receiptList,
                            receiptIds
                        }));
                        dispatch(this.getTransmissions({ receiptIds, dock: filter.dock, shed: filter.shed, print: false }));
                        dispatch(this.getReceiptStorage({ receiptIds, dock: filter.dock, shed: filter.shed, print: true }))
                    } else {
                        dispatch(this.resetPhisicalConfirmation());
                    }

                    if (callback) {
                        callback();
                    }

                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    dispatch(this.resetPhisicalConfirmation());
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        if (callback) {
            callback();
        }
    }

    static receiptByContainer(data, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/transmission/container`, data, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200 && response.data?.data) {
                            const transmissions = response.data.data
                            if (transmissions && transmissions.length > 0) {
                                showMessageToastCustom(translate('general.info'), "Armazenamento gerado com sucesso!", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                                transmissions.forEach(transmission => {
                                    dispatch(actionsPhysicalConfirmation.updateReceipt(transmission.receipt));
                                    if (transmission.receipt?.receiptStorages) {
                                        this.printLabel(transmission.receipt.receiptStorages, transmission.printer);
                                    }
                                });
                            }
                        }
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            };
        }
    }

    static getReceipts(filter, callback) {
        if (navigator.onLine) {
            let msg = '';
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/receipt/filter`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsPhysicalConfirmation.update({ receipts: response.data.data }));
                    }

                    msg = response.data;

                    if (callback) {
                        callback(response.data);
                    }
                }).catch((error) => {
                    if (msg !== '') {
                        showMessageToastCustom(translate('warning', 'general'), msg, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    else {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static getReceiptPaged(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/receipt/paged`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getInvoices(filter, callback) {
        if (navigator.onLine) {
            let msg = '';
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/receipt/invoices`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        msg = response.data;

                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    if (msg !== '') {
                        showMessageToastCustom(translate('warning', 'general'), msg, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    else {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static updateMvm(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                if (!filter.searchMvm) {
                    dispatch(startLoading());
                }
                httpService.instance.post(`/api/mvm/updateMvm`, filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (!filter.searchMvm) {
                            dispatch(actionsPhysicalConfirmation.update(response.data.data));
                        }

                        if (callback) {
                            callback(response.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (filter.searchMvm && callback) {
                        callback();
                    }
                }).finally(() => {
                    if (!filter.searchMvm) {
                        dispatch(endLoading());
                    }
                });
            };
        }
    }


    static reopen(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/mvm/reopen`, filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (response.data.success) {
                            showMessageToastCustom(translate('general.info'), translate('reopen-success', 'physical-confirmation'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static updateLabels(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/transmission/updatelabels`, filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getReceiptsPartNumber(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/receipt/partnumbers`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getGeneralReport(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/receipt/generalReport`;
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response.status === 200 && response.data?.data && callback) {
                            callback(response.data?.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static reportPdfPrinter(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/receipt/report`;
                httpService.instance.post(url, filter,
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data?.data) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getListGeneralReport(filter, pagination, callback) {
        Object.assign(filter, pagination);
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/receipt/generalreport/list`;
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data?.data) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getMonitorPartNumber(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                let url = `/api/transmission/partnumbers`;
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getReceiptStorage(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                httpService.instance.get('/api/receipt/storage', {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    dispatch(actionsPhysicalConfirmation.updateReceiptStorages(response.data.data));
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getLastReceiptStorageByPartnumbers(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                httpService.instance.post('/api/Receipt/storage/last-by-partnumbers', filter, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            };
        }
    }

    static getTransmissions(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                httpService.instance.get('/api/transmission', {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    dispatch(actionsPhysicalConfirmation.updateTransmissions(response.data.data));
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getTransmissionsPaged(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get('/api/transmission/paged', { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    dispatch(actionsPhysicalConfirmation.updateTransmissions(response.data.data));
                    if (callback) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    dispatch(endLoading());
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static checkReceiptsSmallParts(ids, callback) {
        const url = '/api/receipt/checkreceipt';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, ids).then((response) => {
                    if (response.status === 200) {
                        ids.forEach((i) => {
                            dispatch(actionsPhysicalConfirmation.updateSmallPartsReceipt(i, true));
                        })
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static printAnomalyLabel(data, callback) {
        const url = '/api/receipt/printanomaly';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, data).then((response) => {
                    if (response.status === 200) {
                        var data = response.data?.data
                        if (data) {
                            this.printLabel([{ dataToPrint: data }], data.printer);
                        }
                        if (callback) {
                            callback(data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static removeAllConfirmation(receiptIds, callback) {
        if (navigator.onLine) {
            const url = `/api/transmission/deleteAll`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, receiptIds, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        dispatch(actionsPhysicalConfirmation.updateTransmissions([]));

                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static removeConfirmation(transmissionId, callback) {
        if (navigator.onLine) {
            const url = `/api/transmission/${transmissionId}/delete`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static createConfirmation(receiptItem, boxQuantityItems, mdr, accoutingQuantity) {
        return (dispatch) => {
            const confirmation = {};
            Object.assign(confirmation, receiptItem);
            if (accoutingQuantity && accoutingQuantity > 0) {
                confirmation.accoutingQuantity = accoutingQuantity;
            } else {
                confirmation.accoutingQuantity = 1;
            }
            confirmation.boxQuantity = undefined;
            confirmation.boxQuantityItems = boxQuantityItems;
            confirmation.mdr = mdr;
            confirmation.success = false;
            confirmation.message = undefined;
            confirmation.group = false;
            confirmation.type = ENUMS.eTypeConfirmation.Confirmation.value;
            dispatch(actionsPhysicalConfirmation.resetConfirmation());
            dispatch(actionsPhysicalConfirmation.createConfirmation(confirmation));
        };
    }

    static insertInstantConfirmation(confirmation, userConfig, callback) {

        confirmation.printer = userConfig.printer;

        const url = '/api/transmission';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, confirmation).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        const transmission = response.data.data
                        if (transmission && transmission.receipt) {
                            showMessageToastCustom(translate('general.info'), "Armazenamento gerado com sucesso!", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                            dispatch(actionsPhysicalConfirmation.updateReceipt(transmission.receipt));

                            var alternativeMDRAreas = []
                            if (confirmation.alternativeMDRAreas) {
                                alternativeMDRAreas = confirmation.alternativeMDRAreas.replaceAll(" ", "").toUpperCase().split(',')
                            }

                            if (transmission.receipt?.receiptStorages && transmission.receipt?.receiptStorages.length > 0) {
                                if (callback && transmission.receipt?.receiptStorages.find(f => alternativeMDRAreas.includes(f.originLocation.toUpperCase())) && !confirmation.truckKanban) {
                                    callback(transmission.receipt?.receiptStorages.filter(f => alternativeMDRAreas.includes(f.originLocation.toUpperCase())));
                                } else {
                                    this.printLabel(transmission.receipt.receiptStorages, transmission.printer);
                                }
                            }
                        }
                    }

                    if (callback) {
                        callback();
                    }

                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback();
                    }
                }).finally(() => {
                    if (!confirmation.ungroup) {
                        dispatch(endLoading());
                    }
                });
            }
        };
    }

    static alternativeChangeLocation(confirmation, callback) {
        const url = '/api/changelocation/alternative';
        return () => {
            if (navigator.onLine) {
                httpService.instance.post(url, confirmation).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        const data = response.data.data
                        if (data) {
                            showMessageToastCustom(translate('general.info'), `Troca de Locação gerada com sucesso MDR ${data.changeLocation?.mdr}!`, 5000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                            this.printLabel([{ dataToPrint: data.dataToPrint, id: confirmation.idLabel }], confirmation.printer);
                        } else if (confirmation.dataToPrinter) {
                            //Caso não tenha alternativo manda imprimir na portatil a etiqueta principal do recebimento
                            this.printLabel([{ dataToPrint: confirmation.dataToPrinter, id: confirmation.idLabel }], confirmation.printer);
                        }
                    }
                    if (callback) {
                        callback();
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (confirmation.dataToPrinter) {
                        //Caso não tenha alternativo manda imprimir na portatil a etiqueta principal do recebimento
                        this.printLabel([{ dataToPrint: confirmation.dataToPrinter, id: confirmation.idLabel }], confirmation.printer);
                    }
                    if (callback) {
                        callback();
                    }
                })
            }
        };
    }

    static insertConfirmationMassive(data, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/transmission/massive`, data.listDto, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200 && response.data?.data) {
                            const transmissions = response.data.data
                            if (transmissions && transmissions.length > 0) {
                                showMessageToastCustom(translate('general.info'), response.data.message, 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                                let allTransmissions = [];
                                let physicalConfirmationIds = []
                                let printer = undefined;
                                transmissions.forEach(transmission => {
                                    if (transmission.success) {
                                        physicalConfirmationIds.push(transmission.receipt?.physicalConfirmationId);
                                        if (transmission.printer) {
                                            printer = transmission.printer;
                                        }
                                        dispatch(actionsPhysicalConfirmation.updateReceipt(transmission.receipt));
                                        if (transmission.receipt?.receiptStorages) {
                                            transmission.receipt.receiptStorages.forEach(storage => {
                                                allTransmissions.push(storage);
                                            });
                                        }
                                    }
                                });

                                if (allTransmissions && allTransmissions.length > 0) {
                                    let storages = allTransmissions.sort((a, b) => a.partNumberCode - b.partNumberCode);

                                    var alternativeMDRAreas = []
                                    if (data.alternativeMDRAreas) {
                                        alternativeMDRAreas = data.alternativeMDRAreas.replaceAll(" ", "").toUpperCase().split(',')
                                    }

                                    if (callback && storages.find(f => alternativeMDRAreas.includes(f.originLocation.toUpperCase())) && !data.truckKanban) {
                                        return callback(storages.filter(f => alternativeMDRAreas.includes(f.originLocation.toUpperCase())));
                                    } else {
                                        this.printLabel(storages, printer);
                                    }
                                }
                            }

                            if (callback) {
                                callback();
                            }
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        if (callback) {
                            callback()
                        }
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    });
            };
        }
    }

    static insertConfirmationReprocess(data, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/transmission/reprocess`, data, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200 && response.data?.data) {
                            const transmissions = response.data.data
                            if (transmissions && transmissions.length > 0) {
                                let labels = [];
                                let printer = undefined;
                                transmissions.forEach(transmission => {
                                    if (transmission.success) {
                                        if (transmission.printer) printer = transmission.printer;
                                        if (transmission.receipt?.receiptStorages) {
                                            transmission.receipt.receiptStorages.forEach(storage => {
                                                labels.push(storage);
                                            });
                                        }
                                    }
                                });

                                if (labels) {
                                    let storages = labels.sort((a, b) => a.partNumberCode - b.partNumberCode);
                                    this.printLabel(storages, printer);
                                }

                                if (callback) callback(transmissions);
                            } else if (callback) {
                                callback([]);
                            }
                        }
                    }).catch((error) => {
                        dispatch(endLoading());
                        showMessageToastCustom(translate('warning', 'general'), error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    });
            };
        }
    }

    static insertConfirmationGroup(data, callback) {
        const url = '/api/transmission/group';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, data).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        const transmissions = response.data.data
                        let physicalConfirmationIds = []
                        if (transmissions && transmissions.length > 0) {
                            showMessageToastCustom(translate('general.info'), "Armazenamento gerado com sucesso!", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                            transmissions.forEach(transmission => {
                                physicalConfirmationIds.push(transmission.receipt?.physicalConfirmationId);
                                dispatch(actionsPhysicalConfirmation.updateReceipt(transmission.receipt));
                                if (transmission.receipt?.receiptStorages && transmission.receipt?.receiptStorages.length > 0) {
                                    this.printLabel(transmission.receipt.receiptStorages, transmission.printer);
                                }
                            });
                        }

                        dispatch(endLoading());
                        if (callback) {
                            callback(response.data?.data, physicalConfirmationIds);
                        }
                    } else {
                        dispatch(endLoading());
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                });
            }
        };
    }

    static printLabel(labels, print) {
        if (print?.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
            if (navigator.userAgent === 'logisticspwa' && labels.length > 0) {
                const sendToPrinter = {
                    messageType: 'printArray',
                    array: labels,
                    printerManufacturer: print.printerManufacture || ENUMS.ePrinterManufacturerPortable.Honeywell.value,
                    printerAddress: print.macAddress,
                    token: auth.getToken(),
                    urlBase: getUrlPhysicalConfirmationApi(window) + "/api/receipt/print",
                    lng: language()
                };

                window.ReactNativeWebView.postMessage(JSON.stringify(sendToPrinter));
            } else {
                showMessageToastCustom(translate('warning', 'general'), 'Impressão não pode ser realizada', 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        }
    }

    static dataToPrintReceipts(filter, callback) {
        const url = '/api/receipt/datatoprint';
        return (dispatch) => {
            if (navigator.onLine) {
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static sendToPrintInstantConfirmation(data, printer, callback) {
        return (dispatch) => {
            var filter = {
                id: data?.receipt?.id, transmissionId: data?.transmissionId,
                printer: printer, ...data
            }
            dispatch(this.dataToPrintReceipts(filter, (receipt) => {
                if (receipt && receipt.receiptStorages) {
                    this.printLabel(receipt.receiptStorages, printer);
                }
                if (callback) {
                    callback();
                }
            }));
        };
    }

    static getReportLabelsPdf(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get('/api/receipt/label/pdf', { params: filter }, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            };
        }
    }

    static finishPhysicalConfirmation(dataFinished, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put('/api/finalize', dataFinished, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {
                        showMessageToastCustom(translate('general.info'), result.data.message, 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        dispatch(this.resetPhisicalConfirmation());
                        if (callback) {
                            callback();
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static checkPendingItens(dataFinished, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get('/api/receipt/checkpendingitens', { params: dataFinished }, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (result.data.success) {

                        if (callback) {
                            callback(result.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), result.data.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static verifyDuplication(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/receipt/verifyinvoice`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data) {
                            dispatch(actionsPhysicalConfirmation.updateSuppliers(response.data.data));
                            if (callback) {
                                callback(response.data);
                            } else {
                                dispatch(endLoading());
                            }
                        } else {
                            dispatch(endLoading());
                        }
                    }).catch((error) => {
                        dispatch(endLoading());

                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    })
            }
        };
    }

    static getPartNumberQuantity(filter, callback) {
        const url = '/api/partNumberQuantity/paged';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsPhysicalConfirmation.setPartNumberQuantityList(response.data.data));
                        if (callback) {
                            callback(response);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static addPartNumberQuantity(partNumberQuantity, callback) {
        const url = '/api/partNumberQuantity/';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, partNumberQuantity).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updatePartNumberQuantity(partNumberQuantity, callback) {
        const url = '/api/partNumberQuantity/';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, partNumberQuantity).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static deletePartNumberQuantity(id, callback) {
        const url = '/api/partNumberQuantity/' + id;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static uploadBai(data, file, callback) {
        const url = '/api/receipt/upload/bai';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);
                formData.append('MvmNumber', data.mvmNumber);
                formData.append('Shed', data.shed);
                formData.append('Journey', data.journey);
                formData.append('Container', data.container);


                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }

    static getChangeReport(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/transmission/changereport`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data?.data) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getListChangeReport(filter, pagination, callback) {
        Object.assign(filter, pagination);
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/transmission/changereport/list`;
                httpService.instance.get(url, { params: filter },
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response && response.data?.data) {
                            if (callback) {
                                callback(response.data.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static createdTransmission(transmission, callback) {
        const url = '/api/transmission/create';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, transmission).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getShedList() {
        const url = '/api/receipt/shed';
        return (dispatch) => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionsPhysicalConfirmation.setShedList(response.data.data));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), 'mensagem de erro', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    return error;
                });
            }
        };
    }

    static getSummary(physicalConfirmationId, callback) {
        let url = `/api/receipt/summary?physicalConfirmationId=${physicalConfirmationId}`;
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    if (response.status === 200) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                });
            }
        };
    }

    static receiveByLabel(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/transmission/receive/label`;
                httpService.instance.post(url, filter,
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response) {
                            var data = response.data?.data
                            if (data.transmission && data.transmission.receipt) {
                                showMessageToastCustom(translate('general.info'), "Armazenamento gerado com sucesso!", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                                if (data.transmission.receipt?.receiptStorages && data.transmission.receipt?.receiptStorages.length > 0) {
                                    this.printLabel(data.transmission.receipt.receiptStorages, data.transmission.printer);
                                }
                            }
                            callback(data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                        callback();
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static sendAutomaticLow(confirmation, callback) {
        const url = '/api/transmission/automaticlow';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, confirmation).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data?.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static printLabelIdentification(filter, callback) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                let url = `/api/transmission/label/identification`;
                httpService.instance.post(url, filter,
                    { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                        if (response) {
                            var data = response.data?.data
                            if (data && data.length > 0) {
                                let arrayLabel = [];
                                data.forEach(label => {
                                    arrayLabel.push({ dataToPrint: label })
                                });

                                this.printLabel(arrayLabel, filter.printer);
                            }
                            callback(data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getLogs(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/log/filter`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(logAction.setLogs(response.data.data));
                    }
                    if (callback) {
                        callback()
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static ExportLogs(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/log/report`,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        }
    }

    static changeLocation(obj, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.post(`/api/changeLocation`, obj, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        var data = response.data?.data
                        if (data && data.length > 0) {
                            let dataArrayPrint = data.filter(f => !f.erro);
                            if (dataArrayPrint.length > 0) {
                                let arrayLabel = [];
                                dataArrayPrint.forEach(label => {
                                    arrayLabel.push({ dataToPrint: label.dataToPrint })
                                });

                                this.printLabel(arrayLabel, dataArrayPrint[0].printer);
                            }
                        }
                        if (callback) {
                            return callback(data)
                        }
                    }
                    if (callback) {
                        callback()
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static updateMassiveIndicator(id, value) {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.updateMassiveIndicator(id, value));
        };
    }

    static updateVisualIndicator(id, value) {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.updateVisualIndicator(id, value));
        };
    }

    static addReceiptGroup(receipt) {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.addReceiptGroup(receipt));
        };
    }

    static removedReceiptGroup(receipt) {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.removedReceiptGroup(receipt));
        };
    }

    static resetReceipsGroup() {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.resetReceipsGroup());
        };
    }

    static addReceiptCimPallet(receipt) {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.addReceipsCimPallet(receipt));
        };
    }

    static removedReceiptCimPallet(receipt) {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.removedReceipsCimPallet(receipt));
        };
    }

    static resetReceipsCimPallet() {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.resetReceipsCimPallet());
        };
    }

    static setActiveTab(activeTab) {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.setActiveTab(activeTab)); };
    }

    static setFilter(filter) {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.setFilter(filter)); };
    }

    static setPrintSelect(printSelect) {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.setPrintSelect(printSelect)); };
    }

    static clearPrintSelect() {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.clearPrintSelect()); };
    }

    static resetPhisicalConfirmation() {
        return (dispatch) => { dispatch(actionsPhysicalConfirmation.clearPhysicalConfirmation()); };
    }

    static updateDate(partnumberCode, value, key) {
        return (dispatch) => {
            dispatch(actionsPhysicalConfirmation.updateDate(partnumberCode, value, key));
        };
    }

    static getAlternativeMdrPartnumbers(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/alternativemdrpartnumber`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsPhysicalConfirmation.alternativeMdrPartnumberPaged(response.data.data));
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static deleteAlternativeMdrPartnumber(id, callback) {
        if (navigator.onLine) {
            const url = `/api/alternativemdrpartnumber/${id}`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }


    static deleteAlternativeMdrPartnumbers(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/alternativemdrpartnumber/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static insertAlternativeMdrPartnumber(postObj, callback) {
        const url = '/api/alternativemdrpartnumber';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, postObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateAlternativeMdrPartnumber(putObj, callback) {
        const url = '/api/alternativemdrpartnumber';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, putObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static uploadAlternativeMdrPartNumber(file, callback) {
        const url = '/api/alternativemdrpartnumber/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }



    static getQmePartNumbers(filter, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/qmepartnumber`, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsPhysicalConfirmation.qmePartNumberPaged(response.data.data));
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');

                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
        callback();
    }

    static deleteQmePartNumber(id, callback) {
        if (navigator.onLine) {
            const url = `/api/qmepartnumber/${id}`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.delete(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static insertQmePartNumber(postObj, callback) {
        const url = '/api/qmepartnumber';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, postObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static updateQmePartNumber(putObj, callback) {
        const url = '/api/qmepartnumber';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, putObj).then((response) => {
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static uploadQmePartNumber(file, callback) {
        const url = '/api/qmepartnumber/upload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                const formData = new FormData();
                formData.append('File', file);

                httpService.instance.post(url, formData).then((response) => {
                    dispatch(endLoading());

                    if (callback) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());

                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                })
            }
        };
    }


    static deleteSelectedQmePartNumbers(ids, callback) {
        if (navigator.onLine) {
            const url = `/api/qmepartnumber/selected`;
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.put(url, ids, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((result) => {
                    if (callback) {
                        callback(result.data.success);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }
}